import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    NavLink
} from "react-router-dom";
import { useWindowSize } from '../../../Helpers/UseWindowSize';

import Menu          from '../../../Routes/Menu';
import ModalPortalBG from '../Atoms/ModalPortalBG';
import OnClickOutElement from '../../../Helpers/OnClickOutElement'

import '../../../Statics/Scss/Components/Nav.scss';



const Nav = ({ menuVisibility, closeMenu}) => {

    let width    = useWindowSize();
    let isTablet = 767 > width;

    const _renderItem = (list) =>{
        let renderItem = list.map((item, key) => {
            const Tag = item.Url !== "#" ? "a" : "button" ;

            let $item = item.Url ? 
                <React.Fragment key={key}><dd><Tag {...(item.Url !== "#" && { href: item.Url })} {...(item.function && { onClick: item.function })}>{item.Display}</Tag></dd></React.Fragment>
                :
            <React.Fragment  key={key}> <dd><NavLink onClick={ closeMenu }  activeClassName="--active" to={`/${item.Path}`}>{item.Display}</NavLink></dd></React.Fragment>
            return $item;
        })
        return renderItem;
    }

    const _renderGroup = (sections) =>{  
        let renderGroup = sections.map((grupo, key) =>{
                            let $list = _renderItem(grupo.Childrens);
                            return <React.Fragment key={key}> <dt>{grupo.GroupName}</dt> {$list} </React.Fragment>
                        })
        return renderGroup;
    }

    const _renderSection = () =>{
        let renderSection = Menu.map((section, key) =>{
                            let $group = _renderGroup(section.SectionGroup);
                            return <React.Fragment key={key}><dl className={section.SectionClass}>{$group}</dl></React.Fragment>
                        })
        return renderSection;
    }

    return (
        <>
            { isTablet && menuVisibility ?
            
                <ModalPortalBG>

                    <div className="nav-container">
                        <nav className="com-nav --fourxs" ref={OnClickOutElement(closeMenu)}>
                            {_renderSection()}
                        </nav>
                    </div>

                </ModalPortalBG>

                : !isTablet && 

                <nav className="com-nav --fourxs">
                    {_renderSection()}
                </nav>
            
            }
        </>
    );
}



export default Nav;